export default __webpack_public_path__ + "static/media/bg-row.2d47ccfb.png";